import React, { useEffect, useState } from 'react';
import { getAdminReservations, updateReservation } from '../../services/api';
import { Loader2, Clock, CheckCircle, XCircle, Phone, Mail } from 'lucide-react';

const statusMap = {
  pending: { label: 'Bekliyor', color: 'bg-amber-50 text-amber-600', icon: Clock },
  confirmed: { label: 'Onaylandı', color: 'bg-green-50 text-green-600', icon: CheckCircle },
  cancelled: { label: 'İptal', color: 'bg-red-50 text-red-600', icon: XCircle },
};

const AdminReservations = () => {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  const fetch = async () => {
    try {
      const res = await getAdminReservations();
      setReservations(res.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetch(); }, []);

  const changeStatus = async (id, status) => {
    await updateReservation(id, { status });
    fetch();
  };

  const filtered = filter === 'all' ? reservations : reservations.filter(r => r.status === filter);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#3D4A26]" size={32} /></div>;

  return (
    <div>
      <div className="flex items-center gap-2 mb-6">
        {['all', 'pending', 'confirmed', 'cancelled'].map(s => (
          <button key={s} onClick={() => setFilter(s)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              filter === s ? 'bg-[#3D4A26] text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
            }`}
          >
            {s === 'all' ? `Tümü (${reservations.length})` : `${statusMap[s]?.label} (${reservations.filter(r => r.status === s).length})`}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-10 text-center text-sm text-gray-500">
          Henüz rezervasyon yok
        </div>
      ) : (
        <div className="space-y-4">
          {filtered.map(res => {
            const st = statusMap[res.status] || statusMap.pending;
            const StIcon = st.icon;
            return (
              <div key={res.id} className="bg-white rounded-xl border border-gray-200 p-5">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="font-bold text-[#1B1B1B] text-sm">{res.tourTitle}</h3>
                    <p className="text-xs text-gray-500 mt-0.5">{res.selectedDate}</p>
                  </div>
                  <span className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${st.color}`}>
                    <StIcon size={12} />{st.label}
                  </span>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                  <div>
                    <p className="text-xs text-gray-500">Ad Soyad</p>
                    <p className="font-medium">{res.firstName} {res.lastName}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">E-posta</p>
                    <a href={`mailto:${res.email}`} className="font-medium text-[#3D4A26] flex items-center gap-1"><Mail size={12} />{res.email}</a>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Telefon</p>
                    <a href={`tel:${res.phone}`} className="font-medium text-[#3D4A26] flex items-center gap-1"><Phone size={12} />{res.phone}</a>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Katılımcı / Oda</p>
                    <p className="font-medium">{res.participants} kişi • {res.roomType === 'double' ? 'İki Kişilik' : res.roomType === 'single' ? 'Tek Kişilik' : 'İlave Yatak'}</p>
                  </div>
                </div>

                {res.notes && <p className="mt-3 text-sm text-gray-600 bg-gray-50 rounded-lg p-3"><span className="font-medium">Not:</span> {res.notes}</p>}

                {/* Actions */}
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-gray-100">
                  {res.status !== 'confirmed' && (
                    <button onClick={() => changeStatus(res.id, 'confirmed')} className="px-4 py-1.5 bg-green-50 text-green-600 rounded-lg text-xs font-semibold hover:bg-green-100 transition-colors">
                      Onayla
                    </button>
                  )}
                  {res.status !== 'cancelled' && (
                    <button onClick={() => changeStatus(res.id, 'cancelled')} className="px-4 py-1.5 bg-red-50 text-red-600 rounded-lg text-xs font-semibold hover:bg-red-100 transition-colors">
                      İptal Et
                    </button>
                  )}
                  {res.status !== 'pending' && (
                    <button onClick={() => changeStatus(res.id, 'pending')} className="px-4 py-1.5 bg-amber-50 text-amber-600 rounded-lg text-xs font-semibold hover:bg-amber-100 transition-colors">
                      Beklemede
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminReservations;
